import { useEffect, useState } from 'react';

import getLocationService from '../services/getLocation.service';

import { useStatus } from './use-status';

export default function useLocation() {
  /* === STATES ======================================================================= */
  const [location, setLocation] = useState<Record<string, any> | null>(null);
  const { isError, isDone, setStatusError, setStatusDone } = useStatus();

  /* === HANDLERS ===================================================================== */
  const getLocation = async () => {
    try {
      const response = await getLocationService();
      setLocation(response);

      setStatusDone();
    } catch {
      setStatusError();
    }
  };

  /* === EFFECTS ====================================================================== */
  useEffect(() => {
    getLocation();
  }, []);

  /* === RETURN ======================================================================= */
  return { location, isDone, isError };
}
